<template>
    <Tooltip :label="(locked ? 'Unlock ' : 'Lock ') + lockableName" position="left">
        <Button
            type="is-danger"
            :glass="glass"
            :compact="compact"
            :loading="loading"
            :disabled="disabled"
            @click="lockItem"
        >
            <i v-if="locked" class="mdi mdi-lock"></i>
            <i v-else class="mdi mdi-lock-open-variant"></i>
            <slot></slot>
        </Button>
    </Tooltip>
</template>
<script setup>
import Tooltip from '@/js/components/Tooltip.vue';
import Button from '@/js/components/controls/Button.vue';
import { ref } from 'vue';
import axios from 'axios';
import { capturePosthogEvent } from '@/js/composables/usePosthog.js';

const props = defineProps({
    lockableName: {
        type: String,
        default: '',
    },
    lockableType: {
        type: String,
        default: '',
    },
    lockable: {
        type: Object,
        default: () => ({}),
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    glass: {
        type: Boolean,
        default: false,
    },
    compact: {
        type: Boolean,
        default: false,
    },
});

const locked = ref(props.lockable.is_locked);
const loading = ref(false);
const emit = defineEmits(['toggle']);
const lockItem = async () => {
    loading.value = true;
    const wasLocked = locked.value;
    await axios.post(route('api.account.event.budget.lock'), {
        lockable: props.lockable,
        lockableType: props.lockableType,
    });
    if (props.lockableType === 'entry') {
        capturePosthogEvent(wasLocked ? 'budget_entry_unlocked' : 'budget_entry_locked');
    }
    loading.value = false;
    locked.value = !locked.value;
    emit('toggle');
};
</script>
